import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const open = this.element.dataset.open === "true"
    const next = !open
    this.element.dataset.open = next ? "true" : "false"
    const header = this.element.querySelector(".reasoning-header")
    if (header) header.setAttribute("aria-expanded", next ? "true" : "false")
  }
}
